import React, { useState } from "react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import GetAppIcon from "@material-ui/icons/GetApp";
import CommentIcon from '@mui/icons-material/Comment';
import SearchIcon from "@material-ui/icons/Search";
import { inventarioResources } from "../endpoints";
import SnackbarAlert from "./SnackbarAlert";
import DialogComentariosPanel from "./DialogComentariosPanel";
import DialogDetallePanelSodimac from "./DialogDetallePanelSodimac";

const TablaPanel = ({
    disponibles,
    totalRows,
    loading,
    paginationModel,
    onPaginationModelChange,
    sortModel,
    onSortModelChange
}) => {
    const [snack, setSnack] = useState({ open: false, message: null, severity: null });
    const [comentarios, setComentarios] = useState({ open: false, data: null });
    const [adicionales, setAdicionales] = useState({ open: false, rowData: null });

    const verificaAvanceCosto = (row) => {
        return row.teoimp === 0 ? "0.00" : ((row.invimp / row.teoimp) * 100).toFixed(2);
    };

    const getArchivoResultado = (rowData) => {
        setSnack({ open: false, severity: null, message: null });
        inventarioResources.getRutaArchivosFinales(rowData.folio)
            .then(res => res.json())
            .then(data => {
                if (data.length > 0) {
                    const link = document.createElement('a');
                    link.href = `/static/spool/inv_${rowData.folio}/exportaciones/${data[0]}`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    setSnack({ open: true, severity: 'error', message: 'No hay archivos para descargar' });
                }
            }).catch(console.error);
    };

    const columns = [
        { field: 'folio', headerName: 'Folio', width: 80, sortingOrder: ['asc', 'desc']},
        { 
            field: 'fecha', 
            headerName: 'Fecha', 
            width: 100,
            sortingOrder: ['asc', 'desc'],
            valueGetter: (params) => params.row.fecha ? params.row.fecha.split("-").reverse().join("/") : ''
        },
        { field: 'tienda', headerName: 'Tienda', width: 222, sortingOrder: ['asc', 'desc'],
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', lineHeight: '1.2', padding: '6px 0', wordBreak: 'break-word' }}>
                    {params.value}
                </div>
            )
        },
        { field: 'categoria', headerName: 'Categoría', width: 320, sortingOrder: ['asc', 'desc'],
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', lineHeight: '1.2', padding: '6px 0', wordBreak: 'break-word' }}>
                    {params.value}
                </div>
            )},
        { 
            field: 'avance', 
            headerName: 'Avance(%)', 
            width: 110,
            sortingOrder: ['asc', 'desc'],
            renderCell: (params) => {
                const pct = ((params.row.avance || 0) * 100).toFixed(2);
                return (
                    <div style={{ width: '100%' }}>
                        <span>{pct}%</span>
                        <div style={{ height: 6, backgroundColor: '#e0e0e0', borderRadius: 3, overflow: 'hidden' }}>
                            <div style={{ height: '100%', backgroundColor: '#4d4545', width: `${pct}%` }} />
                        </div>
                    </div>
                );
            }
        },
        { 
            field: 'avanceCosto', 
            headerName: 'Avance Costo(%)', 
            width: 131, 
            sortable: false,
            valueGetter: (params) => `${verificaAvanceCosto(params.row)}%`
        },
        { field: 'inv', headerName: 'Inv.', width: 100, sortingOrder: ['asc', 'desc'], valueFormatter: (p) => new Intl.NumberFormat("de-DE").format(p.value || 0) },
        { field: 'teo', headerName: 'Teo.', width: 100, sortingOrder: ['asc', 'desc'], valueFormatter: (p) => new Intl.NumberFormat("de-DE").format(p.value || 0) },
        { field: 'dif', headerName: 'Dif.', width: 100, sortingOrder: ['asc', 'desc'], valueFormatter: (p) => new Intl.NumberFormat("de-DE").format(p.value || 0) },
        { field: 'invimp', headerName: 'Inv.Costo', width: 120, sortingOrder: ['asc', 'desc'], valueFormatter: (p) => new Intl.NumberFormat("de-DE").format(p.value || 0) },
        { field: 'teoimp', headerName: 'Teo.Costo', width: 120, sortingOrder: ['asc', 'desc'], valueFormatter: (p) => new Intl.NumberFormat("de-DE").format(p.value || 0) },
        { field: 'difimp', headerName: 'Dif.Costo', width: 120, sortingOrder: ['asc', 'desc'], valueFormatter: (p) => new Intl.NumberFormat("de-DE").format(p.value || 0) },
        { field: 'operadores', headerName: 'Ops', sortingOrder: ['asc', 'desc'], width: 70 },
        { field: 'estado', headerName: 'Estado', width: 90, sortingOrder: ['asc', 'desc']},
        {
            field: 'acciones',
            type: 'actions',
            headerName: 'Acciones',
            width: 100,
            getActions: (params) => [
                <GridActionsCellItem icon={<GetAppIcon />} label="Descargar" onClick={() => getArchivoResultado(params.row)} />,
                <GridActionsCellItem icon={<CommentIcon />} label="Comentarios" onClick={() => setComentarios({ open: true, data: params.row.comentarios })} />,
                <GridActionsCellItem icon={<SearchIcon />} label="Adicionales" onClick={() => setAdicionales({ open: true, rowData: params.row })} />
            ]
        }
    ];

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <DataGrid
                rows={disponibles}
                getRowId={(row) => row.folio}
                columns={columns}
                rowCount={totalRows}
                loading={loading}
                pageSizeOptions={[10, 25, 50, 100]}
                paginationMode="server"
                sortingMode="server"
                disableColumnMenu
                paginationModel={paginationModel}
                onPaginationModelChange={onPaginationModelChange}
                sortModel={sortModel}
                onSortModelChange={onSortModelChange}
                density="compact"
                getRowHeight={() => 'auto'}
                getEstimatedRowHeight={() => 50}
                getRowClassName={(params) => {
                    const avance = params.row.avance;
                    if (avance === 1) return 'row-completado';
                    if (avance > 0.5 && avance < 1) return 'row-medio';
                    return 'row-bajo';
                }}
                sx={{
                    '& .MuiDataGrid-row, & .MuiDataGrid-cell': {
                        transition: 'none !important',
                    },
                    '& .row-completado': {
                        backgroundColor: '#81c784 !important',
                        '&:hover, &.Mui-hovered': {
                            backgroundColor: '#66bb6a !important',
                        }
                    },
                    '& .row-medio': {
                        backgroundColor: '#ffd54f !important',
                        '&:hover, &.Mui-hovered': {
                            backgroundColor: '#ffca28 !important',
                        }
                    },
                    '& .row-bajo': {
                        backgroundColor: '#e57373 !important',
                        '&:hover, &.Mui-hovered': {
                            backgroundColor: '#ef5350 !important',
                        }
                    }
                }}
            />
            {snack.open && <SnackbarAlert severity={snack.severity} message={snack.message} />}
            {comentarios.open && <DialogComentariosPanel comentarios={comentarios.data} handleClose={() => setComentarios({ open: false, data: null })} />}
            {adicionales.open && <DialogDetallePanelSodimac rowData={adicionales.rowData} handleClose={() => setAdicionales({ open: false, rowData: null })} />}
        </div>
    );
};

export default TablaPanel;